<template>
  <base-container :isLoading="isLoading">
    <!-- <van-nav-bar title="订单详情" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
    <div class="artisan-top-container">
      <van-empty v-if="isNoBus" description="无订单信息" />
      <div v-else class="ali-pay">
        <div class="ordertitle">应付金额</div>
        <div class="ordermount">¥{{order.amount.toFixed(2)}}</div>
        <div style="width:100%;">
          <van-row class="orderitem" type="flex">
            <van-col span="6" style="text-align:right">订单号：</van-col>
            <van-col span="12">{{order.billNo}}</van-col>
          </van-row>
          <van-row class="orderitem" type="flex">
            <van-col span="6" style="text-align:right">支付方式：</van-col>
            <van-col span="12">{{payTypeName}}</van-col>
          </van-row>
          <van-row class="orderitem" type="flex">
            <van-col span="6" style="text-align:right">业务说明：</van-col>
            <van-col span="12">{{busTypeName}}</van-col>
          </van-row>
        </div>
        <div v-if="isStartPay" style="color:green;text-align:center">
          <van-loading v-if="!order.isPay" size="3rem" color="#c71d24" vertical>支付中...</van-loading>
          <div v-else>
            <van-icon size="3rem" name="checked" />
            <br />
            <b>支付完成</b>
            <van-button class="artisan-btn" type="info" block round to="/order">查看订单</van-button>
            <van-button class="artisan-btn" type="info" block round to="/">回首页</van-button>
          </div>
        </div>
        <van-button v-else class="artisan-btn" type="info" block round @click="startPay">去支付</van-button>
      </div>
    </div>
    <form name="form"></form>
  </base-container>
</template>

<script>
import {
  getPayInfo,
  getPayTypeName,
  getBusTypeName,
  queryPay,
} from "@/api/order";
import { fmoney } from "@/util/util";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      isNoBus: false,
      isStartPay: false,
      timer: "",
      order: {
        billNo: "",
        busType: "",
        payType: "",
        amount: 0,
        isPay: false,
      },
    };
  },
  computed: {
    payTypeName() {
      return getPayTypeName(this.order.payType);
    },
    busTypeName() {
      return getBusTypeName(this.order.busType);
    },
  },
  created() {
    if (this.$route.query.out_trade_no) {
      this.order.billNo = this.$route.query.out_trade_no;
      this.isStartPay = true;
      this.query();
    } else {
      this.order.billNo = this.$route.query.billNo;
      this.order.busType = this.$route.query.busType;
      this.order.payType = this.$route.query.payType;
      this.order.amount = this.$route.query.amount;
    }
  },
  methods: {
    fmoney,
    // getOrder() {
    //   this.isLoading = true;
    //   getPayInfo(this.billNo).then((res) => {
    //     this.isNoBus = false;
    //     this.isLoading = false;
    //     this.order = res.data.value;
    //   });
    // },
    startPay() {
      Dialog.confirm({
        title: "提示",
        message: "确认去支付？",
      }).then(() => {
        this.isLoading = true;
        getPayInfo(this.order.billNo)
          .then((res) => {
            this.isLoading = false;
            this.order = res.data.value;
            if (this.order.h5Url) {
              this.isStartPay = true;
              // let referLink = document.createElement("a");
              // referLink.href = this.order.h5Url;
              // document.body.appendChild(referLink);
              // referLink.click();
              document.form.method = "post";
              document.form.action = this.order.h5Url;
              document.form.submit();
              // window.location.href = this.order.h5Url;
            } else {
              Toast.fail("发起支付失败，请重新下单！");
            }
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    query() {
      queryPay(this.order.billNo).then((res) => {
        this.order = res.data.value;
        if (this.order.isPay) {
          if (this.timer) clearInterval(this.timer);
          switch (this.order.busType) {
            case "WaterRecharge":
              this.toWaterResult();
              break;
            case "Register":
              this.toParamPage("hosregisterSuccess", {
                billNo: this.order.billNo,
              });
              break;
            case "ReserveRegister":
              this.toParamPage("reserveRegisterSuccess", {
                billNo: this.order.billNo,
              });
              break;
          }
        } else {
          if (!this.timer) {
            this.timer = setInterval(this.query, 5000);
          }
        }
      });
    },
    toWaterResult() {
      this.toPage("/waterresult", {
        waterNo: this.order.waterFeeRechargeInfo.waterNo,
        waterName: this.order.waterFeeRechargeInfo.waterName,
        orgName: this.order.waterFeeRechargeInfo.orgName,
        amount: this.order.amount,
      });
    },
    toPage(path, query) {
      this.$router.push({ path, query });
    },
    toParamPage(name, params) {
      this.$router.push({ name, params });
    },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer);
    },
  },
};
</script>

<style>
.ali-pay {
  color: blue;
  background-color: #f7f8fa;
}

.wx-pay {
  color: green;
}

.ordertitle {
  color: #bdbebd;
  margin-top: 70px;
  text-align: center;
}

.ordermount {
  color: #000;
  margin-top: 10px;
  font-weight: bold;
  font-size: 32px;
  font-family: inherit;
  text-align: center;
}

.orderitem {
  padding-bottom: 5px;
  border-bottom: #f2f3f5 1px solid;
  margin-top: 15px;
  color: #000;
  font-weight: inherit;
  font-style: inherit;
  font-size: 100%;
  font-family: inherit;
}
</style>